module.exports = __webpack_public_path__ + "static/media/83.cffd4d5d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sports/svg/83.svg
// module id = 171
// module chunks = 0